import slugify from 'slugify';
import {
    AttrField,
    HasManyField,
    HasOneField,
    NumberField,
    OrmModel,
    PrimaryKey,
    StringField,
    UidField,
} from 'vuex-orm-decorators';
import { LatLng } from 'leaflet';
import { Model } from '@vuex-orm/core';
import { v4 as uuid } from 'uuid';
import ActiveImage from '@/image/ActiveImage';
import Coordinates from '@/location/Coordinates';
import ImageContract from '@/image/ImageContract';
import InactiveImage from '@/image/InactiveImage';
import LocationContract from '@/location/LocationContract';
import LocationTheme from '@/location/LocationTheme';
import MapImage from '@/image/MapImage';
import Marker from '@/marker/Marker';
import MarkerContract from '@/marker/MarkerContract';
import BodyContract from '@/marker/BodyContract';
import Study from '@/study/Study';
import StudyContract from '@/study/StudyContract';

@OrmModel('locations')
export default class Location extends Model implements LocationContract {
    @PrimaryKey()
    @UidField(() => uuid())
    public id!: string;

    @StringField(LocationTheme.DARK)
    public theme!: LocationTheme;

    @StringField()
    public title!: string;

    @AttrField()
    public about_campus!: BodyContract;

    @AttrField()
    private coordinates!: Coordinates;

    @NumberField()
    public weight!: number;

    @HasOneField(ActiveImage, 'location_id')
    public image_active!: ImageContract;

    @HasOneField(InactiveImage, 'location_id')
    public image_inactive!: ImageContract;

    @HasOneField(MapImage, 'location_id')
    public map!: ImageContract;

    @HasManyField(Marker, 'location_id')
    public markers!: Array<MarkerContract>;

    @HasManyField(Study, 'location_id')
    public studies!: Array<StudyContract>;

    @AttrField()
    private studies_marker_coordinates!: Coordinates;

    public latLng(): LatLng {
        return new LatLng(
            this.coordinates.y_axis,
            this.coordinates.x_axis,
        );
    }

    public latLngStudiesMarker(): LatLng {
        return new LatLng(
            this.studies_marker_coordinates.y_axis,
            this.studies_marker_coordinates.x_axis,
        );
    }

    public slug(): string {
        return slugify(this.title, {
            lower: true,
        });
    }
}
